import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'TAG',
  collections: {
    articlesIds: { get: 'articles' },
  },
});
